import { initGraphQLTada } from 'gql.tada';

import type { introspection } from './graphql-env.d.ts';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    DateTime: string;
  };
}>();

export type Scalar<T extends string> = ReturnType<typeof graphql.scalar<T>>;

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { readFragment } from 'gql.tada';
